'use client';

import { createPortal } from 'react-dom';
import { ProposalFeedSkeleton } from '@/components/launchpad/proposal-feed-skeleton';
import { ListingDiscoveryActionsSkeleton } from '@/components/shared/listing-discovery-actions-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';
import { useHydrated } from '@/hooks/ui/use-hydrated';
import { LISTING_INDEX_PAGE_STACK_CLASS } from '@/lib/ui/layout';

export default function LaunchpadLoading(): React.ReactNode {
  const mounted = useHydrated();
  const mobileFab = (
    <div
      aria-hidden
      data-proposal-creation-loading
      className="fixed right-4 z-sticky bottom-[calc(5.5rem+env(safe-area-inset-bottom))] sm:hidden"
    >
      <Skeleton className="size-14 rounded-full" />
    </div>
  );

  return (
    <div className={LISTING_INDEX_PAGE_STACK_CLASS} aria-busy="true">
      <div className="flex items-center justify-between gap-2">
        <Skeleton className="h-7 w-28 shrink-0" />
        <div className="flex items-center gap-2">
          <ListingDiscoveryActionsSkeleton />
          <Skeleton className="hidden h-9 w-36 rounded-control sm:block lg:hidden" />
        </div>
      </div>

      <ProposalFeedSkeleton />
      {mounted && createPortal(mobileFab, document.body)}
    </div>
  );
}
